import React from "react";
import PasswordGate from "./components/password-gate";
import MainContent from "./MainContent"; // whatever your existing app is

function App() {
  return (
    // <PasswordGate>
      <MainContent />
    // </PasswordGate>
  );
}

export default App;
